import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { HTMLAttributes } from "react"

interface ButtonProps {
  action: () => void
  label: string
  icon?: IconProp
  disabled?: boolean
}

function Button({
  action,
  label,
  className = "",
  icon,
  disabled = false,
  ...props
}: ButtonProps & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      onClick={disabled ? undefined : action}
      aria-disabled={disabled}
      aria-hidden
      className={`btn ${className}`}
      {...props}
    >
      {icon && <FontAwesomeIcon icon={icon} className="mr-1" />}
      {label}
    </div>
  )
}

export default Button
